import script from "./Svara.vue?vue&type=script&setup=true&lang=ts"
export * from "./Svara.vue?vue&type=script&setup=true&lang=ts"

import "./Svara.vue?vue&type=style&index=0&id=5b26c04d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b26c04d"]])

export default __exports__